var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.50004H4.58333M4.58333 5.50004H19.25M4.58333 5.50004V18.3334C4.58333 18.8196 4.77649 19.2859 5.1203 19.6297C5.46412 19.9736 5.93044 20.1667 6.41667 20.1667H15.5833C16.0696 20.1667 16.5359 19.9736 16.8797 19.6297C17.2235 19.2859 17.4167 18.8196 17.4167 18.3334V5.50004H4.58333ZM7.33333 5.50004V3.66671C7.33333 3.18048 7.52649 2.71416 7.8703 2.37034C8.21412 2.02653 8.68044 1.83337 9.16667 1.83337H12.8333C13.3196 1.83337 13.7859 2.02653 14.1297 2.37034C14.4735 2.71416 14.6667 3.18048 14.6667 3.66671V5.50004M9.16667 10.0834V15.5834M12.8333 10.0834V15.5834",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.950931be0e6f6d0043309ee99820d175.svg";
export { ForwardRef as ReactComponent };